<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-komoditas-pedagang-perantara" lazy-validation>
        <h3 style="margin: 0% auto;"><b>Tambahkan Pesanan Pengiriman Baru</b></h3>
        <small>Kontrak > {{kodePenjualan}} > Tambahkan Pesanan Pengiriman</small>
        <v-layout row wrap>

            <!-- Bagian Umum -->
            <v-flex xs6>
                <v-subheader><b>Bagian Umum</b></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Tipe Pengiriman Pesanan" name="tipePengirimanPesanan" v-model="tipePengirimanPesanan" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Kode Penjualan" name="kodePenjualan" v-model="kodePenjualan" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Nomor Kontrak" name="contractNumber" v-model="contractNumber" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <!-- Penjelasan Komoditas Kontrak -->
            <v-flex xs6>
                <v-subheader><b>Penjelasan Komoditas Kontrak</b></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <div class="layout row border">
                    <div class="layout column">
                        <p class="flex my-1 text-xs-left"><b>Penjual</b></p>
                        <p class="flex my-1 text-xs-left">Nama: <b>{{penjual}}</b></p>
                        <p class="flex my-2 text-xs-left">Entitas: <b></b></p>
                        <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPenjual}}</b></p>
                    </div>                

                    <div class="layout column">
                        <p class="flex my-1 text-xs-left"><b>Pembeli</b></p>
                        <p class="flex my-1 text-xs-left">Nama: <b>{{pembeli}}</b></p>
                        <p class="flex my-2 text-xs-left">Entitas: <b></b></p>
                        <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPembeli}}</b></p>
                    </div>                
                </div>
            </v-flex>

            <!-- Pelaku Usaha -->
            <v-flex xs6>
                <v-subheader><b>Pelaku Usaha</b></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Nama Pelanggan" name="pelanggan" v-model="pelanggan" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Kontak Pelanggan" name="kontakPelanggan" v-model="kontakPelanggan" type="number" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-select
                v-model="selectPenyediaJasaPengiriman"
                :items="tipePenyediaJasaPengiriman"
                label="Penyedia Jasa Pengiriman"
                ></v-select>
            </v-flex>

            <v-flex lg12 sm12>
                <v-select
                v-model="selectContactPenyediaJasaPengiriman"
                :items="tipeContactPenyediaJasaPengiriman"
                label="Kontak Penyedia Jasa Pengiriman"
                ></v-select>
            </v-flex>

            <!-- Penjelasan Pesanan Pengiriman -->
            <v-flex xs6>
                <v-subheader><b>Penjelasan Pesanan Pengiriman</b></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Komoditas" name="komoditas" v-model="komoditas" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Tingkat Kualitas" name="tingkatKualitas" v-model="selectKualitas" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Musim" name="musim" v-model="musim" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Kuantitas" name="kuantitas" v-model="kuantitas" suffix="Ton" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <!-- Penjemputan -->
            <v-flex xs12>
                <v-subheader><b>Penjemputan</b></v-subheader>
            </v-flex>

            <v-flex sm6 lg6>
                <v-menu
                class="pr-2"
                ref="statDatePenjemputan"
                lazy
                :close-on-content-click="false"
                v-model="startDateMenuPenjemputan"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-22"
                max-width="290px"
                :return-value.sync="startDatePenjemputan"
                >
                <v-text-field
                    slot="activator"
                    label="Tanggal Penjemputan"
                    v-model="startDatePenjemputan"
                    append-icon="event"
                    readonly
                ></v-text-field>
                <v-date-picker v-model="startDatePenjemputan" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="startDateMenuPenjemputan = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.statDatePenjemputan.save(startDatePenjemputan)">OK</v-btn>
                </v-date-picker>
                </v-menu>
            </v-flex>

            <v-flex sm6 lg6>
                <v-menu
                ref="startTimePenjemputan"
                lazy
                :close-on-content-click="false"
                v-model="startTimeMenuPenjemputan"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-24"
                max-width="290px"
                :return-value.sync="startTimePenjemputan"
                >
                <v-text-field
                    slot="activator"
                    label="Waktu Penjemputan"
                    v-model="startTimePenjemputan"
                    append-icon="access_time"
                    readonly
                ></v-text-field>
                <v-time-picker v-model="startTimePenjemputan">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="startTimeMenuPenjemputan = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.startTimePenjemputan.save(startTimePenjemputan)">OK</v-btn>                
                </v-time-picker>
                </v-menu>
                <small>Untuk Pagi Hari Pilih <b>AM</b> dan Siang Hari Pilih <b>PM</b></small>
            </v-flex> 

            <v-flex lg12 sm12>
                <v-text-field label="Nama Pengirim" name="pengirim" v-model="pengirim" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Lokasi Penjemputan" name="lokasiPenjemputan" v-model="lokasiPenjemputan">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Kode Penjualan" name="kodePenjualan" v-model="kodePenjualanPenjemputan">
                </v-text-field>
            </v-flex>

            <!-- Pengiriman -->
            <v-flex xs12>
                <v-subheader><b>Pengiriman</b></v-subheader>
            </v-flex>

            <v-flex sm6 lg6>
                <v-menu
                class="pr-2"
                ref="statDate"
                lazy
                :close-on-content-click="false"
                v-model="startDateMenuPengiriman"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-22"
                max-width="290px"
                :return-value.sync="startDatePengiriman"
                >
                <v-text-field
                    slot="activator"
                    label="Tanggal Pengiriman"
                    v-model="startDatePengiriman"
                    append-icon="event"
                    readonly
                ></v-text-field>
                <v-date-picker v-model="startDatePengiriman" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="startDateMenuPengiriman = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.statDate.save(startDatePengiriman)">OK</v-btn>
                </v-date-picker>
                </v-menu>
            </v-flex>

            <v-flex sm6 lg6>
                <v-menu
                ref="startTime"
                lazy
                :close-on-content-click="false"
                v-model="startTimeMenuPengirimanPengiriman"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-24"
                max-width="290px"
                :return-value.sync="startTimePengiriman"
                >
                <v-text-field
                    slot="activator"
                    label="Waktu Pengiriman"
                    v-model="startTimePengiriman"
                    append-icon="access_time"
                    readonly
                ></v-text-field>
                <v-time-picker v-model="startTimePengiriman">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="startTimeMenuPengiriman = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.startTime.save(startTimePengiriman)">OK</v-btn>                
                </v-time-picker>
                </v-menu>
                <small>Untuk Pagi Hari Pilih <b>AM</b> dan Siang Hari Pilih <b>PM</b></small>
            </v-flex> 

            <v-flex lg12 sm12>
                <v-text-field label="Nama Penerima" name="penerima" v-model="penerima">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Lokasi Penjemputan" name="lokasiPengiriman" v-model="lokasiPengiriman">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Kode Penjualan" name="kodePenjualan" v-model="kodePenjualanPengiriman">
                </v-text-field>
            </v-flex>

            <!-- Kontrak Pengiriman -->
            <v-flex xs12>
                <v-subheader><b>Kontrak Pengiriman</b></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-select
                v-model="selectFaktur"
                :items="tipeFaktur"
                label="Faktur"
                ></v-select>
            </v-flex>

            <v-flex sm6 lg6>
                <v-menu
                ref="endDate"
                lazy
                class="pr-2"
                :close-on-content-click="false"
                v-model="endDateMenuPembayaranPengiriman"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-22"
                min-width="290px"
                :return-value.sync="endDatePembayaranPengiriman"
                >
                <v-text-field
                    slot="activator"
                    label="Jangka Tanggal Akhir Pembayaran"
                    v-model="endDatePembayaranPengiriman"
                    append-icon="event"
                    readonly
                ></v-text-field>
                <v-date-picker v-model="endDatePembayaranPengiriman" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="endDateMenuPembayaranPengiriman = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.endDate.save(endDatePembayaranPengiriman)">OK</v-btn>
                </v-date-picker>
                </v-menu>
            </v-flex>

            <v-flex sm6 lg6>
                <v-menu
                ref="endTime"
                lazy
                :close-on-content-click="false"
                v-model="endTimeMenuPembayaranPengiriman"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-24"
                max-width="290px"
                :return-value.sync="endTimePembayaranPengiriman"
                >
                <v-text-field
                    slot="activator"
                    label="Jangka Waktu Akhir Pembayaran"
                    v-model="endTimePembayaranPengiriman"
                    append-icon="access_time"
                    readonly
                ></v-text-field>
                <v-time-picker v-model="endTimePembayaranPengiriman" >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="endTimeMenuPembayaranPengiriman = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.endTime.save(endTimePembayaranPengiriman)">OK</v-btn>                
                </v-time-picker>
                </v-menu>
                <small>Untuk Pagi Hari Pilih <b>AM</b> dan Siang Hari Pilih <b>PM</b></small>
            </v-flex> 

            <v-flex lg12 sm12>
                <v-text-field label="Perkiraan Jarak Tempuh" name="jarakTempuh" v-model="jarakTempuh" type="number" suffix="Km">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Perkiraan Waktu Perjalanan" name="waktuPerjalanan" v-model="waktuTempuh" suffix="Jam" type="number">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field label="Nilai Komisi" name="nilaiKomisi" v-model="nilaiKomisi" prefix="Rp. " suffix=".00" type="number">
                </v-text-field>
            </v-flex>

            <!-- Kondisi Kontrak Pengiriman -->
            <v-flex xs6>
                <v-subheader><b>Kondisi Kontrak Pengiriman</b></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-textarea label="Kondisi Kontrak Umum" name="kontrakUmum" v-model="kontrakUmum" outline>
                </v-textarea>
            </v-flex>

            <v-flex lg12 sm12>
                <v-textarea label="Kondisi Kontrak Khusus" name="kontrakKhusus" v-model="kontrakKhusus" outline>
                </v-textarea>
            </v-flex>

        </v-layout>        

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="back">Batal</v-btn>
          <v-btn color="secondary" @click="saveTemplate">Simpan Template</v-btn>
          <v-btn color="primary" form="tambahkan-komoditas-pedagang-perantara" @click="getPesananPengiriman">Lanjutkan dan Ulas</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  components: {
  },
  data: () => ({
    valid: true,
    date: null,
    modal: false ,

    kodePenjualan: localStorage.kontrakKodePenjualan,
    tipePengirimanPesanan: 'Penjual ke Pembeli',

    penjual: localStorage.kontrakPenjual,
    kontakPenjual: localStorage.kontrakKontakPenjual,
    pembeli: localStorage.kontrakPembeli,
    kontakPembeli: localStorage.kontrakKontakPembeli,

    pelanggan: 'AGRICULTURAL TRADING PTY LTD',
    kontakPelanggan: '081380762278',
    selectPenyediaJasaPengiriman: null,
    tipePenyediaJasaPengiriman: [
        'Baraka Sarana Tama',
        'Rajasa Trans',
        'Nusa Dharma Ekspresindo',
    ], 
    selectContactPenyediaJasaPengiriman: null,
    tipeContactPenyediaJasaPengiriman: [
        '081384553628',
        '081384372819',
    ], 

    komoditas: localStorage.kontrakKomoditas,
    selectKualitas: localStorage.kontrakSelectKualitas,
    musim: localStorage.kontrakMusim,
    kuantitas: localStorage.kontrakKuantitas,

    startDateMenuPenjemputan: false,
    startDatePenjemputan: null,
    startTimeMenuPenjemputan: false,
    startTimePenjemputan: null,
    penerima: localStorage.kontrakPenerima,
    lokasiPenjemputan: localStorage.kontrakLokasiPenjemputan,
    kodePenjualanPenjemputan: null,

    startDateMenuPengiriman: false,
    startDatePengiriman: null,
    startTimeMenuPengiriman: false,
    startTimePengiriman: null,
    pengirim: localStorage.kontrakPengirim,
    lokasiPengiriman: localStorage.kontrakLokasiPengiriman,
    kodePenjualanPengiriman: null,

    selectFaktur: null,
    tipeFaktur: [
        'Penyedia Pengiriman ke Pelanggan',
    ], 
    endDateMenuPembayaranPengiriman: false,
    endDatePembayaranPengiriman: null,
    endTimeMenuPembayaranPengiriman: false,
    endTimePembayaranPengiriman: null,
    jarakTempuh: null,
    waktuTempuh: null,
    nilaiKomisi: null,

    kontrakUmum: null,
    kontrakKhusus: null,

    currentDate: null,

  }),

  computed: {
    tipeDocs() {
      return [
        'Dokumen Usaha Dagang Perantara',
        this.kodePenjualan
      ]
    },

    contractNumber(){
        return 'K1920-' + this.kodePenjualan;
    }
  },

  methods: {

    closeDialog () {
      this.$parent.isActive = false;
    },

    back(){
      window.getApp.$emit('APP_KOMODITAS');
      // return '/pemerintah';
    },

    saveTemplate(){
        //   window.getApp.$emit('APP_SIMPAN_TEMPLATE');
    },

    getPesananPengiriman (){
        localStorage.kontrakID = this.contractNumber;

        localStorage.kontrakPelanggan = 'AGRICULTURAL TRADING PTY LTD',
        localStorage.kontrakKontakPelanggan = '081380762278',
        localStorage.kontrakSelectPenyediaJasaPengiriman = this.selectPenyediaJasaPengiriman,
        localStorage.selectContactPenyediaJasaPengiriman = this.selectContactPenyediaJasaPengiriman,

        localStorage.startDatePenjemputan = this.startDatePenjemputan,
        localStorage.startTimePenjemputan = this.startTimePenjemputan,
        localStorage.kontrakLokasiPenjemputan = this.lokasiPenjemputan,
        localStorage.kontrakKodePenjualanPenjemputan = this.kontrakKodePenjualanPenjemputan,

        localStorage.endDatePengiriman = this.endDatePengiriman,
        localStorage.endTimePengiriman = this.endTimePengiriman,
        localStorage.kontrakLokasiPengiriman = this.lokasiPengiriman,
        localStorage.kontrakKodePenjualanPengiriman = this.kontrakKodePenjualanPengiriman,

        localStorage.selectFaktur = this.selectFaktur,
        localStorage.endDatePembayaranPengiriman = this.endDatePembayaranPengiriman,
        localStorage.endTimePembayaranPengiriman = this.endTimePembayaranPengiriman,
        localStorage.jarakTempuh = this.jarakTempuh,
        localStorage.waktuTempuh = this.waktuTempuh,
        localStorage.nilaiKomisi = this.nilaiKomisi,

        localStorage.kontrakUmum = this.kontrakUmum,
        localStorage.kontrakKhusus = this.kontrakKhusus,

        localStorage.currentDatePengiriman = moment().format('DD-MM-YYYY');
        localStorage.kontrakPesananPengiriman = 'true'

        window.getApp.$emit('APP_ULAS_PESANAN_PENGIRIMAN');

    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
